<template>
  <el-container id="logHome">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-header style="margin:0;padding:0">
        <el-menu :default-active="paths" class="el-menu-demo" mode="horizontal"
                 background-color="#FFFFFF" active-text-color="#1250B4">
          <el-menu-item index="/home/log/logUser" @click.native.stop="handleSelectMenu('/home/log/logUser')">
            人员操作日志
          </el-menu-item>
          <el-menu-item index="/home/log/logDev" @click.native.stop="handleSelectMenu('/home/log/logDev')">
            设备操作日志
          </el-menu-item>
          <el-menu-item index="/home/log/logScene" @click.native.stop="handleSelectMenu('/home/log/logScene')">
            场景执行日志
          </el-menu-item>
          <el-menu-item index="/home/log/logTiming" @click.native.stop="handleSelectMenu('/home/log/logTiming')">
            定时执行日志
          </el-menu-item>
        </el-menu>
      </el-header>
      <el-main style="background: #FFFFFF;">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

export default {
  name:"logHome",
  computed:{},
  data() {
    return {
      h_text:"日志管理",
      paths:this.$route.path,
      li_h_text:[
        {"text":"管理设置","colour":"#B7B7B7","pages":""}
      ]
    };
  },
  methods:{ /*方法存放*/
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    if (this.$route.path === "/home/log") { /*判断表格未点击过场景*/
      this.paths = "/home/log/logUser";
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#logHome {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.div_left {
  background: #F4F4F4;
}
</style>



// WEBPACK FOOTER //
// src/pages/logs/log.vue